/**
 * Eldra — solo popup Klaviyo.
 * Alla X: toglie il popup dal DOM (niente veli/fantasmi) e toglie i lock scroll di Klaviyo.
 * Non tocca carrello, menu, ELIL né altre parti del tema.
 */
(function () {
  if (window.__eldraKlaviyoUnlockBound) return;
  window.__eldraKlaviyoUnlockBound = true;

  var KEY = 'eldra_kl_dismissed';
  var closed = false;
  var busy = false;
  var watch = null;
  var t1 = null;
  var t2 = null;
  var t3 = null;

  try {
    closed = sessionStorage.getItem(KEY) === '1';
  } catch (e) {
    closed = false;
  }

  function setClosed(on) {
    closed = !!on;
    try {
      if (on) sessionStorage.setItem(KEY, '1');
      else sessionStorage.removeItem(KEY);
    } catch (e2) {
      /* ignore */
    }
    document.documentElement.classList.toggle('eldra-kl-closed', closed);
    if (closed) document.documentElement.classList.remove('eldra-klaviyo-form-open');
  }

  function otherUiOpen() {
    if (document.querySelector('.eldra-cart-shell.is-open, cart-drawer.active, cart-drawer.is-open, .cart-drawer.is-open')) {
      return true;
    }
    if (document.body.classList.contains('eldra-mobile-menu-open')) return true;
    if (document.body.classList.contains('eldra-mobile-search-open')) return true;
    if (document.querySelector('.eldra-home-menu[open], .eldra-global-menu[open], details.eldra-home-search[open]')) {
      return true;
    }
    if (document.body.classList.contains('eldra-bloy-popup-open') || document.body.classList.contains('eldra-bloy-premi-opening')) {
      return true;
    }
    if (document.querySelector('.eldra-account-shell.is-open')) return true;
    if (
      document.documentElement.classList.contains('eldra-incisione-scroll-locked') ||
      document.body.classList.contains('eldra-incisione-scroll-locked') ||
      document.body.classList.contains('eldra-incisione-modal-open')
    ) {
      return true;
    }
    return false;
  }

  function isThemeNode(el) {
    if (!(el instanceof Element)) return true;
    if (/^(SCRIPT|STYLE|LINK|META|NOSCRIPT|TEMPLATE|HEADER|FOOTER|MAIN)$/i.test(el.tagName)) return true;
    if (el.id && /^shopify-section/i.test(el.id)) return true;
    if (
      el.matches(
        'cart-drawer, .cart-drawer, .eldra-cart-shell, header, footer, main, #MainContent, .shopify-section, .eldra-account-shell, .eldra-floating-stack, [id^="shopify-pc__"]'
      )
    ) {
      return true;
    }
    var bits = String(el.className || '') + ' ' + (el.id || '');
    return /shopify-section|eldra-|announcement-bar|header-|footer-/i.test(bits);
  }

  function isKlaviyoPopupRoot(el) {
    if (!(el instanceof HTMLElement) || isThemeNode(el)) return false;
    var bits = String(el.className || '') + ' ' + (el.id || '');
    if (/klaviyo|kl-private|kl-teaser|kl-form/i.test(bits)) return true;
    try {
      if (el.querySelector('.klaviyo-close-form, .klaviyo-form, [class*="klaviyo-form"], [class*="kl-private"]')) {
        return true;
      }
    } catch (err) {
      return false;
    }
    return false;
  }

  /** Toglie proprio i nodi del popup — così non resta nessun velo. */
  function removeKlaviyoPopups() {
    if (busy || otherUiOpen()) return;
    busy = true;
    try {
      var parents = [document.body, document.documentElement];
      for (var p = 0; p < parents.length; p++) {
        var parent = parents[p];
        if (!parent) continue;
        var kids = Array.prototype.slice.call(parent.children);
        for (var i = 0; i < kids.length; i++) {
          var el = kids[i];
          if (el === document.body || el === document.head) continue;
          if (isKlaviyoPopupRoot(el)) el.remove();
        }
      }
    } finally {
      busy = false;
    }
  }

  /** Solo lock messi da Klaviyo; non forza overflow sul body (carrello). */
  function clearKlaviyoScrollLock() {
    if (otherUiOpen()) return;
    var html = document.documentElement;
    var body = document.body;
    ['kl-prevent-scroll', 'klaviyo-prevent-scroll', 'klaviyo-modal-open', 'kl-disable-body-scroll'].forEach(function (c) {
      html.classList.remove(c);
      body.classList.remove(c);
    });
    [html, body].forEach(function (node) {
      [
        'overflow',
        'overflow-x',
        'overflow-y',
        'position',
        'top',
        'left',
        'right',
        'width',
        'height',
        'padding-right',
        'pointer-events',
        'touch-action',
      ].forEach(function (prop) {
        if (node.style.getPropertyValue(prop)) node.style.removeProperty(prop);
      });
    });
  }

  function finishClose() {
    setClosed(true);
    try {
      if (window._klOnsite && typeof window._klOnsite.closeForm === 'function') {
        window._klOnsite.closeForm();
      }
    } catch (e3) {
      /* ignore */
    }
    removeKlaviyoPopups();
    clearKlaviyoScrollLock();
    window.clearTimeout(t1);
    window.clearTimeout(t2);
    window.clearTimeout(t3);
    t1 = window.setTimeout(function () {
      removeKlaviyoPopups();
      clearKlaviyoScrollLock();
    }, 50);
    t2 = window.setTimeout(function () {
      removeKlaviyoPopups();
      clearKlaviyoScrollLock();
    }, 400);
    t3 = window.setTimeout(function () {
      removeKlaviyoPopups();
      clearKlaviyoScrollLock();
    }, 1200);
    startWatch();
  }

  function startWatch() {
    if (watch || !document.body) return;
    watch = new MutationObserver(function (mutations) {
      if (!closed || busy || otherUiOpen()) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          removeKlaviyoPopups();
          clearKlaviyoScrollLock();
          return;
        }
      }
    });
    watch.observe(document.body, { childList: true });
  }

  function stopWatch() {
    if (!watch) return;
    watch.disconnect();
    watch = null;
  }

  function finishOpen() {
    setClosed(false);
    stopWatch();
    document.documentElement.classList.add('eldra-klaviyo-form-open');
  }

  function isCloseControl(t) {
    if (!(t instanceof Element) || isThemeNode(t)) return false;
    var root = t.closest('[class*="klaviyo"], [class*="kl-private"], [id*="klaviyo"], .needsclick');
    if (!root || isThemeNode(root)) return false;
    if (!isKlaviyoPopupRoot(root) && !root.closest('[class*="klaviyo"], [class*="kl-private"]')) return false;
    if (t.closest('.klaviyo-close-form')) return true;
    if (
      t.closest(
        '[aria-label*="Close"], [aria-label*="close"], [aria-label*="Chiudi"], [aria-label*="chiudi"]'
      )
    ) {
      return true;
    }
    var btn = t.closest('button, [role="button"], a');
    if (!btn) return false;
    var label = ((btn.getAttribute('aria-label') || '') + ' ' + (btn.textContent || ''))
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return /no,\s*grazie|no grazie|non ora|chiudi|close|dismiss|skip/.test(label);
  }

  window.addEventListener('klaviyoForms', function (event) {
    var type = event && event.detail && event.detail.type;
    if (!type) return;
    if (type === 'open' || type === 'embedOpen' || type === 'stepView' || type === 'formViewed') {
      finishOpen();
      return;
    }
    if (
      type === 'close' ||
      type === 'embedClose' ||
      type === 'redirectedToUrl' ||
      type === 'submit' ||
      type === 'stepSubmit'
    ) {
      finishClose();
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!isCloseControl(event.target)) return;
      finishClose();
    },
    true
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!isCloseControl(event.target)) return;
      finishClose();
    },
    { capture: true, passive: true }
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (document.documentElement.classList.contains('eldra-klaviyo-form-open') || document.querySelector('.klaviyo-close-form')) {
      finishClose();
    }
  });

  if (closed) {
    document.documentElement.classList.add('eldra-kl-closed');
    window.setTimeout(finishClose, 0);
  }
})();
